import { memo, useCallback } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MonitorWeightOutlinedIcon from '@mui/icons-material/MonitorWeightOutlined';
import BlindsOutlinedIcon from '@mui/icons-material/BlindsOutlined';
import TopicIcon from '@mui/icons-material/Topic';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TripIcon from '../../../../shared/common-utilities/utils/TripIcon';
import DescriptionIcon from '@mui/icons-material/Description';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import WhatshotOutlinedIcon from '@mui/icons-material/WhatshotOutlined';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import MapIcon from '@mui/icons-material/Map';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button, ButtonGroup, ListItemIcon, Typography } from '@mui/material';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { baseUrl, getMovement } from "../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts";
import { TripOriginSharp } from "@mui/icons-material";
import ShipmentMoveBlIcon from "../../../../shared/common-utilities/utils/ShipmentMoveBlIcon";
import WeightKgIcon from "../../../../shared/common-utilities/utils/WeightKgIcon";
import WarningIcon from '@mui/icons-material/Warning';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import TemperatureHigh from "../../../../shared/common-utilities/Qualifications/TemperatureHigh";
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import SpeedIcon from '@mui/icons-material/Speed';
import StraightenIcon from '@mui/icons-material/Straighten';

const style = {
  width: '100%',
  maxWidth: 360,
  marginTop: 0,
  marginBottom: 1,
  paddingTop: 0,
  paddingBottom: 0,
  border: 1, borderColor: '#70a9ca',
  bgcolor: '#a6d6f7',
};

const minText = {
  width: 150,
  maxWidth: "98%",
  display: 'flex'
};
const directText = {
  width: 100,
  maxWidth: "98%",
  display: 'flex'
};
const icText = {
  width: 'auto',
  maxWidth: "98%",
  display: 'flex'
};

const custText = {
  width: 200,
  maxWidth: "98%",
  display: 'flex',
  marginLeft:'auto'
};
const actionText = {
  width: 'auto',
  maxWidth: "98%",
  display: 'flex',
  marginLeft:'auto'
};

const apiService = commonApiService();

const MovementDetails = (props) => {
  const sendApi = useCallback((id, url) => {
    const urlSuffix = 'Microsoft.NAV.' + url;
    apiService.postWithId(getMovement, null, id, urlSuffix, {}).then(res => {
      const url = res.value;
      if (url) {
        window.open(url, '_blank');
      }
    })
  }, []);

  const selectTile = useCallback((data) => {
    data.selected = !data.selected;
    props?.sendToParent(data)
  }, []);

  return (
    <>
      {props?.tileItems?.map((mov, index) => (
        <List key={index} sx={style} component="nav" dense aria-label="mailbox folders" onClick={() => selectTile(mov)} >
          
          <ListItem divider sx={{ px: .2, background: '#6ab6eb'}}>
          <ListItemIcon sx={{ minWidth: 25, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <LocalShippingOutlinedIcon sx={{ fontSize: '18px' }} color='primary' />
            </ListItemIcon>
            <Typography sx={directText} variant="subtitle2" noWrap={true} component="h2">
              {mov.kindofMovement}
            </Typography>

            
            <ListItemIcon sx={{ minWidth: 25, }}>
              <MarkUnreadChatAltIcon color='primary' />
            </ListItemIcon>
            <ListItemIcon sx={{ minWidth: 25, }}>
              <WarningIcon color='warning' />
            </ListItemIcon>
            <ListItemIcon sx={{ minWidth: 25, }}>
              <WhatshotIcon color='danger' />
            </ListItemIcon>
            <ListItemIcon sx={{ minWidth: 25, }}>
              <TemperatureHigh color='primary' />
            </ListItemIcon>
            
            <Typography sx={actionText} variant="subtitle2" noWrap={true} component="h2">
              Action : 4
            </Typography>
            {/* <ListItemIcon sx={{ minWidth: 25, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <ArticleOutlinedIcon sx={{ fontSize: '18px' }} size="small" color='primary' />
            </ListItemIcon>
            <Typography sx={custText} variant="subtitle2" noWrap={true} component="h2">
              {mov.customerName}
            </Typography> */}
           
          </ListItem>
          <ListItem sx={{ px: .5, py: 0, }}>
            <ListItemIcon sx={{ minWidth: 25, }}>
              <FmdGoodIcon color='primary' />
            </ListItemIcon>
            <Typography sx={minText} variant="subtitle2" noWrap={true} component="h2">
              {mov.startAddressCity}
            </Typography>
           
            

            <ListItemIcon sx={{ minWidth: 25, }}>
              <FmdGoodIcon color='primary' />
            </ListItemIcon>

            <Typography sx={minText} variant="subtitle2" noWrap={true} component="h2">
              {mov.fileRef} - {mov.endAddressCity}
            </Typography>

          </ListItem>
          <ListItem divider sx={{ px: .5, py: 0, opacity: 1 }}>
            <ListItemIcon sx={{ minWidth: 25, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <AccessAlarmsIcon color='neutral.main' sx={{ opacity: 1, fontSize: '16px', }} />
            </ListItemIcon>
            <Typography sx={minText} variant="caption" noWrap={true} component="h2">
              {mov.startDate}, {mov.startTime}
            </Typography>
            <ListItemIcon sx={{ minWidth: 25, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <AccessAlarmsIcon color='neutral.main' sx={{ opacity: 1, fontSize: '16px', }} />
            </ListItemIcon>

            <Typography sx={minText} variant="caption" noWrap={true} component="h1">
              {mov.endDate}, {mov.endTime}
            </Typography>

          </ListItem>

          <ListItem divider sx={{ px: .2, }}>
          <ListItemIcon sx={{ minWidth: 25,  textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <BlindsOutlinedIcon sx={{ fontSize: '22px' }} color='primary' />
            </ListItemIcon>
            <Typography sx={icText} variant="subtitle2" noWrap={true} component="h2" >
              {/* Volume (m3) :  */}
              <Typography variant="subtitle2" component="h2" color="primary"> {mov.volume}</Typography>
            </Typography>
            <ListItemIcon sx={{ minWidth: 25, marginLeft:2, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              {/* <MonitorWeightOutlinedIcon sx={{ fontSize: '18px' }} size="small" color='primary' /> */}
              <WeightKgIcon sx={{ fontSize: '18px' }} size="small" color='primary' />
            </ListItemIcon>
            <Typography sx={icText} variant="subtitle2" noWrap={true} component="h2"  >
              {/* Weight (kg) :  */}
              <Typography variant="subtitle2" component="h2" color="primary"> {mov.weight}</Typography>
            </Typography>

            <ListItemIcon sx={{ minWidth: 25, marginLeft:2, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <SpeedIcon sx={{ fontSize: '22px' }} size="small" color='primary' />
            </ListItemIcon>
            <Typography sx={icText} variant="subtitle2" noWrap={true} component="h2"  >
              <Typography variant="subtitle2" component="h2" color="primary"> {mov.weight}</Typography>
            </Typography>
            
            <ListItemIcon sx={{ minWidth: 25, marginLeft:2, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <StraightenIcon sx={{ fontSize: '22px' }} size="small" color='primary' />
            </ListItemIcon>
            <Typography sx={icText} variant="subtitle2" noWrap={true} component="h2"  >
              <Typography variant="subtitle2" component="h2" color="primary"> {mov.weight}</Typography>
            </Typography>
            
          </ListItem>
          <ListItem divider sx={{ px: .5, backgroundColor: 'info.light' }}>
            <ButtonGroup variant="text" aria-label="text button group">
              <Button sx={{ p: 0, width: 30 }} onClick={() => sendApi(mov?.id, 'getUrlMovement')}><TopicIcon sx={{ fontSize: '18px' }} size="small" color='danger' /></Button>
              <Button sx={{ p: 0, width: 30 }} onClick={() => sendApi(mov?.id, 'getUrlShipment')}><ShipmentMoveBlIcon sx={{ fontSize: '18px' }} size="small" color='primary' /></Button>
              <Button sx={{ p: 0, width: 30 }} onClick={() => sendApi(mov?.id, 'getUrlFileTpt')}><DescriptionIcon  sx={{ fontSize: '18px' }} size="small" color='primary' /></Button>
              {/* <Button sx={{ p: 0, width: 30 }} onClick={() => sendApi(mov?.id, 'getUrlTrip')}><TripIcon sx={{ fontSize: '18px' }} size="small" color='primary' /></Button> */}
            </ButtonGroup>
            <ListItemIcon sx={{ minWidth: 25, textAlign: 'center', marginLeft: 'auto', display: 'flex', justifyContent: 'center' }}>
              <BlindsOutlinedIcon sx={{ fontSize: '18px' }} color='primary' />

            </ListItemIcon>
            {/* <Typography sx={{ display: 'flex' }} variant="subtitle2" noWrap={true} component="h2" color="#3B66B0" >
              LL (lm) : <Typography variant="subtitle2" component="h2" color="secondary.main"> {mov.length}</Typography>
            </Typography> */}
          </ListItem>
        </List>
      ))}
    </>
  );
};

export default MovementDetails;